import * as React from 'react'
import { connect } from 'react-redux'
import { Operation } from '../../../domain/Operation'
import { ApplicationState } from '../../../redux/ApplicationState'
import { addTracepoint } from '../../../redux/V2/TracepointRule/actions'
import { TracepointFormWrapper } from './tracepoint-form-wrapper'
import TracepointFormFields, { TracepointFormState } from './tracepoint-form-fields'
import TracepointFormErrors from './tracepoint-form-errors'

interface OwnProps {
    onExit: () => void
    operation: Operation
    allowedDurations: number[]
    showNotifyOnFirstSlow: boolean
    annotationDefaults?: { [key: string]: string | number }
    error?: string | null
}

interface StateProps {
    environment: string
    service: string
}

interface DispatchProps {
    addTracepoint: (operation: number, environment: string, service: string, state: TracepointFormState) => void
}

type Props = StateProps & DispatchProps & OwnProps

type State = {
    error?: string | null
    processing: boolean
}

class AddTracepointForm extends React.Component<Props, State> {
    public static defaultProps = {
        annotationDefaults: {},
        showNotifyOnFirstSlow: false,
    }

    constructor(props: Props) {
        super(props)

        this.state = { error: props.error, processing: false }
    }

    public render = (): React.ReactNode => {
        const { allowedDurations, onExit, operation, annotationDefaults, showNotifyOnFirstSlow, error } = this.props

        return (
            <TracepointFormWrapper>
                <TracepointFormErrors error={error} />
                <TracepointFormFields
                    allowedDurations={allowedDurations}
                    annotationDefaults={annotationDefaults}
                    onSubmit={this.handleSubmit}
                    transaction={operation.identifier}
                    showNotifyOnFirstSlow={showNotifyOnFirstSlow}
                    renderFormActions={isValid => (
                        <>
                            <button className="btn btn-primary" disabled={!isValid}>
                                start
                                {this.state.processing && <i className="fa fa-spinner fa-spin" />}
                            </button>{' '}
                            <button className="btn btn-secondary" onClick={onExit}>
                                cancel
                            </button>
                        </>
                    )}
                />
            </TracepointFormWrapper>
        )
    }

    private handleSubmit = async (state: TracepointFormState) => {
        try {
            this.setState({ processing: true })
            await this.props.addTracepoint(this.props.operation.id, this.props.environment, this.props.service, state)
            this.props.onExit()
        } catch (error) {
            this.setState({ error: error.message })
        } finally {
            this.setState({ processing: false })
        }
    }
}

export default connect<StateProps, DispatchProps>(
    (globalState: ApplicationState, props: Props): StateProps => {
        const { environment, service } = globalState.tidewaysContext

        return {
            environment,
            service,
        }
    },
    {
        addTracepoint,
    },
)(AddTracepointForm)
